module.exports = __webpack_public_path__ + "img/person.d6ed0cc1.svg";